import * as React from 'react';

import { Image as ImageType, renditions } from '../../types';
import Image from "../Image";
import { MediaQuery } from "../Image/Image";
import s from './QuotesWithImage.module.scss';

interface QuoteWithImageItem {
    quote: string;
    name?: string;
    title?: string;
    image: ImageType;
}

export interface QuotesWithImageProps {
    items: Array<QuoteWithImageItem>;
}


const QuotesWithImage: React.FC<QuotesWithImageProps> = ({ items = [] }) => {
    const getMediaQueries = (renditions: renditions): MediaQuery[] => {
        let mediaQueries = [];
        mediaQueries = [
            ...mediaQueries,
            { minWidth: 960, src: renditions?.xl?.src },
            { minWidth: 768, src: renditions?.large?.src },
            { minWidth: 480, src: renditions?.medium?.src },
            { minWidth: 360, src: renditions?.small?.src },
        ];
        return mediaQueries.filter((x) => x.src);
    }

    return (
        <div className={s.Root} >
            {items.map((item, index) => (
                <div className={s.QuoteWrapper}>
                    <div className={s.Quote} key={index}>
                        <span dangerouslySetInnerHTML={{ __html: item.quote }} />
                    </div>
                    <div className={s.Info}>
                        {item.name && <p>{item.name}{item.title && <span> - {item.title}</span>}</p>}
                    </div>
                    <Image
                        image={item.image}
                        containerClass={s.ImageContainer}
                        className={s.Image}
                        mediaQueries={getMediaQueries(item.image.renditions)}
                    />
                </div>
            ))}
        </div>
    );
};

export default QuotesWithImage;
